module.exports = __webpack_public_path__ + "static/media/icon_appliances.e15951b7.svg";